module.exports = __webpack_public_path__ + "static/img/file_typescript.7e73d4d0.png";